import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import EncuentraTuRitmo from './pages/EncuentraTuRitmo';
import HazloPosible from './pages/HazloPosible';
import EnMovimiento from './pages/EnMovimiento';
import DetrasDelEscenario from './pages/DetrasDelEscenario';
import Hablemos from './pages/Hablemos';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="encuentra-tu-ritmo" element={<EncuentraTuRitmo />} />
            <Route path="hazlo-posible" element={<HazloPosible />} />
            <Route path="en-movimiento" element={<EnMovimiento />} />
            <Route path="detras-del-escenario" element={<DetrasDelEscenario />} />
            <Route path="hablemos" element={<Hablemos />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
